import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useState, useEffect } from "react";

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Show after scrolling past hero section
      if (window.pageYOffset > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const handleCTAClick = () => {
    window.open("https://payhip.com/b/NWTP2", "_blank");
  };

  return (
    <div
      className={`fixed bottom-4 sm:bottom-6 right-4 sm:right-6 z-40 transition-all duration-500 ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0 pointer-events-none"
      }`}
    >
      <Button
        onClick={handleCTAClick}
        size="lg"
        className="group relative bg-primary hover:bg-primary/90 text-primary-foreground shadow-intense hover:shadow-glow hover:scale-105 animate-glow-pulse overflow-hidden transition-all duration-300 text-base sm:text-lg px-5 sm:px-6 py-4 sm:py-5 micro-bounce hover-glow"
      >
        <span className="relative z-10 flex items-center gap-2 font-bold">
          Jetzt kaufen
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-2 transition-transform duration-300" />
        </span>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
      </Button>
    </div>
  );
};

export default FloatingCTA;
